<script setup lang="ts">
import type { Ref } from 'vue'

const { value: learnMore } = useField('learnMore')
const state = inject('state') as Ref<any>
</script>

<template>
  <!-- Add FormProgress component at the top -->
  <div class="mb-6">
    <FormProgress class="!mb-6" />
  </div>

  <div class="text-2xl sm:text-3xl text-red text-center font-bold mb-8 px-2">
    Do you want to learn more about Medicare Advantage plans with flexible OTC
    allowance benefits of
    {{ state?.minOtcLtd ?? '$500' }}/year or more?
  </div>

  <div class="grid grid-cols-2 gap-4 max-w-md mx-auto">
    <Button
      wide
      size="lg"
      type="submit"
      variant="darkBlue"
      @click="learnMore = true"
      class="font-bold text-xl sm:text-2xl"
    >
      YES
    </Button>
    <Button
      wide
      size="lg"
      type="submit"
      variant="darkBlue"
      @click="learnMore = false"
      class="font-bold text-xl sm:text-2xl"
    >
      NO
    </Button>
    <Button
      wide
      size="lg"
      type="submit"
      variant="gray"
      class="col-span-2 font-medium text-xl"
      @click="learnMore = null"
    >
      SKIP
    </Button>
  </div>
</template>
